// extracted by mini-css-extract-plugin
module.exports = {"topBarLogo":"logos_topBarLogo__1aDJ9"};